import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LoginFormComponent } from '@spartacus/user/account/components';

@Component({
  selector: 'cx-login-form',
  templateUrl: './custom-login-form.component.html',
  styleUrl: './custom-login-form.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomLoginComponent extends LoginFormComponent {

}